class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="number"]');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');

    this.minusButton.addEventListener('click', this.onButtonClick.bind(this));
    this.plusButton.addEventListener('click', this.onButtonClick.bind(this));
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.input.addEventListener('input', this.onInputChange.bind(this));

    this.validateButtons();
  }

  onButtonClick(event) {
    event.preventDefault();
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;
    const max = this.input.max ? parseInt(this.input.max, 10) : null;
    let value = parseInt(this.input.value, 10) || min;

    if (event.currentTarget.name === 'plus') {
      value = max !== null ? Math.min(value + 1, max) : value + 1;
    } else {
      value = Math.max(value - 1, min);
    }

    this.input.value = value;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    this.validateButtons();
  }

  onInputChange() {
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;
    const max = this.input.max ? parseInt(this.input.max, 10) : null;
    let value = parseInt(this.input.value, 10);

    if (isNaN(value)) value = min;
    if (value < min) value = min;
    if (max !== null && value > max) value = max;

    this.input.value = value;
    this.validateButtons();
  }

  validateButtons() {
    const value = parseInt(this.input.value, 10) || 0;
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;
    const max = this.input.max ? parseInt(this.input.max, 10) : null;

    this.minusButton.disabled = value <= min;
    this.plusButton.disabled = max !== null && value >= max;
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}